import { LaunchDarklyRenderer } from '@renderer/utils/launchdarkly.renderer'

const MEETING_BRIEF_GENERATION_FLAG_KEY = 'meeting-brief-generation'

/**
 * Gates brief GENERATION only — does not affect display of existing
 * briefs. When `false`:
 *
 *  - the cell's "Create Brief" button hides
 *  - the drawer footers' "Create Brief" / "Regenerate Brief" buttons hide
 *  - the `scheduled-meeting:trigger-brief` auto-trigger consumer ignores
 *    the event (biggest cost saver — that's the only path that spawns
 *    agents without an explicit user click)
 *
 * Existing briefs still render everywhere (cell preview, drawer Brief
 * tab, toast BriefPreview) — display is cheap and there's no value in
 * hiding briefs the user already paid to generate.
 *
 * Defaults to `true` — kill switch semantics. Flip to `false` in
 * LaunchDarkly to throttle server-side cost without a deploy.
 *
 * Non-reactive: reads once at mount, matching the codebase's other
 * LaunchDarkly call sites. A session restart picks up the flipped value.
 */
export function useMeetingBriefGenerationEnabled(): boolean {
  return LaunchDarklyRenderer.get<boolean>(MEETING_BRIEF_GENERATION_FLAG_KEY, true)
}
